<template lang="html">
  <div class="add-newsletter tier tier-three">
    <div class="tier-content">
      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <mailchimp-form
        v-model="siteNewsletter"
        :errors="errors"
        @submit="submitNewsletter"
      >
      </mailchimp-form>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {createCompanySiteMailchimpData} from '@/lib/mailchimps'

import MailchimpForm from '@/components/forms/MailchimpForm'

export default {
  name: 'AddNewsletter',

  components: {
    MailchimpForm
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      siteNewsletter: {},
      errors: {},
      title: 'Add Newsletter'
    }
  },

  methods: {
    submitNewsletter() {
      createCompanySiteMailchimpData(
        this.companyId,
        this.siteId,
        this.siteNewsletter
      )
        .then((newsletter) => {
          this.triggerNotification('success', 'Mailchimp', 'connected')
          this.$emit('updatePage')

          window.setTimeout(() => {
            this.$router.push({
              name: 'newsletter',
              params: {
                companyId: this.companyId,
                siteId: this.siteId,
                newsletterId: newsletter.data.id
              }
            })
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  }
}
</script>

<style lang="sass">
.add-newsletter
</style>
